function mapFromDbToElement(seat) {
    let svgInfo = seat?.svgInfo;
    if (svgInfo === null || svgInfo === undefined) {
        svgInfo = {};
    }
    svgInfo.x = svgInfo.x || 0;
    svgInfo.y = svgInfo.y || 0;
    svgInfo.rotation = svgInfo.rotation || 0;
    svgInfo.scale = svgInfo.scale || 1;
    svgInfo.svg = svgInfo.svg || '';
    svgInfo.model = svgInfo.model || '';

    return {
        id: seat.id,
        name: seat.name,
        nameI18n: seat.nameI18n,
        x: svgInfo.x,
        y: svgInfo.y,
        rotation: svgInfo.rotation,
        scale: svgInfo.scale,
        model: svgInfo.model,
        svg: svgInfo.svg,
        bookable: seat.bookable,
    };
}

export default mapFromDbToElement;
